import "../App.css";
import { StcFetch } from "../Components/StcFetch";

function StcDashboard() {
  return (
    <div className="App">
      <header
        className="App-header"
        style={{ justifyContent: "flex-start", padding: "8px 0" }}
      >
        <h3 style={{ marginTop: 4, marginBottom: 4, fontSize: 18 }}>
          STC Dashboard
        </h3>
        <StcFetch />
      </header>
    </div>
  );
}

export default StcDashboard;
